import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid"
import { flexRender, HeaderGroup } from "@tanstack/react-table"
import clsx from "clsx"

interface Props<T> {
    headerGroups: HeaderGroup<T>[]
}

export function THead<T>({ headerGroups }: Props<T>) {
    return (
        <thead>
            {headerGroups.map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th
                            key={header.id}
                            className={clsx(
                                "py-3.5 pr-3 text-left text-sm font-semibold text-gray-900 dark:text-gray-100",
                                (header.column.columnDef.meta as { className: string | undefined } | undefined)
                                    ?.className
                            )}
                        >
                            {header.isPlaceholder ? null : header.id !== "name" ? (
                                <div
                                    {...{
                                        className: header.column.getCanSort() ? "cursor-pointer select-none" : "",
                                        onClick: header.column.getToggleSortingHandler(),
                                    }}
                                >
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                    {{
                                        asc: <ChevronUpIcon className="ml-2 inline-block size-5" />,
                                        desc: <ChevronDownIcon className="ml-2 inline-block size-5" />,
                                    }[header.column.getIsSorted() as string] ?? null}
                                </div>
                            ) : (
                                flexRender(header.column.columnDef.header, header.getContext())
                            )}
                        </th>
                    ))}
                </tr>
            ))}
        </thead>
    )
}
